/// <reference types="@angular/localize" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const getSentryEnvironment = (): string => {
  const hostname = window.location.hostname;
  const suffix = '.frontforce.be';

  if (hostname.endsWith(suffix)) {
    const subdomain = hostname.slice(0, -suffix.length);
    return subdomain.length > 0 ? subdomain : hostname;
  }

  return hostname;
};

console.debug(`Sentry enabled: ${environment.sentryEnabled}, environment: ${getSentryEnvironment()}`);

if (environment.production && environment.sentryEnabled) {
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    release: `emergency-web@${environment.appVersion}`,
    environment: getSentryEnvironment(),
    enableLogs: true,
    sendDefaultPii: true,
    ignoreErrors: [/^0 Unknown Error$/],
  });
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
